module.exports = __webpack_public_path__ + "static/bottle-dunkin-extra-extra-32oz _ 48oz-c7d7ef531e5d30fd9d929233be107a0f.png";